import { Box, Flex } from "@chakra-ui/react";
import { APP_PLATFORM } from "../../config";
import { Platform } from "../../models";
import { Content } from "../Content";
import { Header } from "../Header";
import { Sidebar } from "../Sidebar";
import IFrameComponent from "./IFrameComponent";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { useCallback, useState, useEffect, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { selectUnsavedState, setShowUnSaveModelInfo } from "../../app/slice/unsavedSlice";
import useUnsavedBar from "../../hooks/useUnsavedBar";
import ReviewStickyWidgetV2 from "../ReviewCollector/ReviewStickyWidgetV2";
import WelcomePage from "../WelcomePage";
import { useLocation } from "react-router-dom";
import HelpModal from "../HelpModal/HelpModal";
import { callHandleOnSubmit } from "../../utils/conditionSubmitHandler";
import { useCentralConfirmModal } from "../../context/ConfirmModalContext";
import { useFlowBuilderSession } from "@reconvert/react-ui-component";

const PageLayout = () => {
  const dispatch = useAppDispatch();
  const location = useLocation();
  const queryParams = useMemo(() => new URLSearchParams(location.search), [location.search]);
  const showWelcomePage = queryParams.get("showWelcomePage") || "";
  const { t } = useTranslation();
  const { showUnSaveModelInfo, isConditionCreateOrUpdate } = useAppSelector(selectUnsavedState);
  const { handleDiscard, handleSave } = useUnsavedBar();
  const { openConfirmModal, setConfirmLoading } = useCentralConfirmModal();
  const [isConfirmLoading, setIsConfirmLoading] = useState(false);
  const { getSelectedConditionFromSession } = useFlowBuilderSession();

  const closeUnSavedModal = useCallback(() => {
    dispatch(setShowUnSaveModelInfo({ callback: () => {} }));
  }, [dispatch]);

  const [showFlowBuilder, setShowFlowBuilder] = useState(true);

  useEffect(() => {
    const selectedCondition = getSelectedConditionFromSession();

    if (showWelcomePage === "true" && !selectedCondition) {
      setShowFlowBuilder(false);
    }
  }, [showWelcomePage, getSelectedConditionFromSession]);

  useEffect(() => {
    if (!showUnSaveModelInfo.open) return;

    const callback = showUnSaveModelInfo.callback;

    openConfirmModal({
      title: t("Would you like to save your changes?"),
      okButtonText: t("Save"),
      cancelButtonText: t("Discard"),
      content: t("Warning: Clicking discard at this stage will delete any unsaved changes"),
      onConfirm: async () => {
        setIsConfirmLoading(true);
        if (isConditionCreateOrUpdate) {
          callHandleOnSubmit();
        } else {
          const response = await handleSave();

          response && callback?.();
        }

        closeUnSavedModal();
        setIsConfirmLoading(false);
      },
      onCancel: async () => {
        closeUnSavedModal();
        await handleDiscard();
        callback?.();
      },
    });
  }, [
    showUnSaveModelInfo.open,
    showUnSaveModelInfo.callback,
    openConfirmModal,
    t,
    isConditionCreateOrUpdate,
    handleSave,
    handleDiscard,
    closeUnSavedModal,
    dispatch,
  ]);

  useEffect(() => {
    setConfirmLoading(isConfirmLoading);
  }, [isConfirmLoading, setConfirmLoading]);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        flex: 1,
        height: "100vh",
      }}
    >
      {APP_PLATFORM === Platform.Wix && <Header />}
      <Flex flex={1} minHeight={0}>
        <Sidebar showFlowBuilder={showFlowBuilder} setShowFlowBuilder={setShowFlowBuilder} />
        {APP_PLATFORM === Platform.Shopify && <ReviewStickyWidgetV2 />}
        {!showFlowBuilder && APP_PLATFORM === Platform.Shopify ?  <WelcomePage /> : <Content />}
      </Flex>
      <IFrameComponent />
      <HelpModal />
    </Box>
  );
};

export default PageLayout;
